import styled from "styled-components";
import { space } from "styled-system";
import styledMap from "styled-map";

import theme from "config/theme";

export const Tabs = styled.div`
  width: 100%;
  white-space: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
  display: block;
  text-align: center;
  position: relative;
  font-size: ${theme.font.size.upsilon};
  -webkit-overflow-scrolling: touch;

  @media (max-width: ${theme.size.tablet}) {
    font-size: ${theme.font.size.delta};
  }

  ${space};
`;

export const Tab = styled.button`
  margin: 0 15px;
  padding: 10px 0 15px;
  border: none;
  cursor: pointer;
  background-color: transparent;
  position: relative;
  transition: color ${theme.transition};

  &:first-child {
    margin-left: 30px;
  }

  &:last-child {
    margin-right: 30px;
  }

  &::after {
    content: "";
    width: 50%;
    height: 2px;
    display: table;
    margin: 15px auto 0;
    border-radius: 10px;
    transition: ${theme.transition};
    transform: ${props => (props.active ? "scale(1)" : "scale(0)")};

    background-color: ${styledMap("active", {
      true: theme.color.primary,
      false: "transparent"
    })};
  }

  font-weight: ${styledMap("active", {
    true: theme.font.weight.bold,
    false: theme.font.weight.regular
  })};

  color: ${styledMap("active", {
    true: theme.color.gray,
    false: theme.color.gray4
  })};

  &:hover {
    color: ${theme.color.gray};
  }

  &:focus {
    outline: none;
  }
`;

export default Tabs;
